import { type ReactNode } from "react";
import { CheckCircle2 } from "lucide-react";

export function AiStockQrFavicon() {
  return (
    <img
      src="/imagens/favicon.png"
      alt=""
      className="mx-auto h-16 w-16 object-contain brightness-0"
    />
  );
}

type Props = {
  title: string;
  primary: ReactNode;
  secondary?: ReactNode;
  successBadge?: boolean;
};

/** Telas finais da rota QR — mesmo padrão visual de “Imagem enviada”. */
export function AiStockQrStatusScreen({ title, primary, secondary, successBadge = false }: Props) {
  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center bg-white px-8 pt-[max(1.5rem,env(safe-area-inset-top))] pb-[max(1.5rem,env(safe-area-inset-bottom))]">
      <div className="flex w-full max-w-[18rem] flex-col items-center text-center">
        <AiStockQrFavicon />
        <h1 className="mt-4 text-2xl font-bold tracking-tight text-gray-900">{title}</h1>
        <p className="mt-5 text-base leading-relaxed text-gray-900">{primary}</p>
        {secondary ? <p className="mt-4 text-sm text-gray-500">{secondary}</p> : null}
        {successBadge ? (
          <span className="mt-6 inline-flex items-center gap-1.5 rounded-full border border-[#1E8E3E]/20 bg-[#E6F4EA] px-3.5 py-1.5 text-sm font-medium text-[#1E8E3E]">
            <CheckCircle2 className="h-4 w-4 shrink-0" aria-hidden />
            Enviado com sucesso
          </span>
        ) : null}
      </div>
    </div>
  );
}

export function qrSessionStatusCopy(
  status: string | null | undefined,
  error: string | null | undefined,
): { title: string; primary: ReactNode; secondary?: ReactNode } {
  const err = (error ?? "").trim();
  const st = (status ?? "").trim();

  if (st === "expired" || /expirad/i.test(err)) {
    return {
      title: "Sessão expirada",
      primary: (
        <>
          O tempo para envio da imagem terminou.
          <br />
          Você já pode fechar esta tela.
        </>
      ),
    };
  }
  if (st === "cancelled") {
    return {
      title: "Sessão encerrada",
      primary: (
        <>
          O envio da imagem foi encerrado.
          <br />
          Você já pode fechar esta tela.
        </>
      ),
    };
  }
  if (st === "used" || st === "ready" || st === "processing" || /já foi utilizado/i.test(err)) {
    return {
      title: "Sessão já utilizada",
      primary: (
        <>
          Este QR Code já foi utilizado.
          <br />
          Você já pode fechar esta tela.
        </>
      ),
    };
  }
  if (!st || /inválid|não encontrada|nao encontrada|link inválido/i.test(err)) {
    return {
      title: "Sessão inválida",
      primary: (
        <>
          Este link de captura não é válido.
          <br />
          Você já pode fechar esta tela.
        </>
      ),
    };
  }

  return {
    title: "Não foi possível continuar",
    primary: (
      <>
        {err || "Esta sessão não está disponível."}
        <br />
        Você já pode fechar esta tela.
      </>
    ),
  };
}
